import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
import { toast } from "@/hooks/use-toast";
import { LogOut, User, Shield } from "lucide-react";
import { useContext } from "react";
import AuthContext from "@/context/AuthContextInstance";

interface NavigationProps {
  userRole?: "staff" | "admin";
  userName?: string;
}

const Navigation = ({
  userRole = "staff",
  userName = "User",
}: NavigationProps) => {
  const { logout, manualLogoutRef } = useContext(AuthContext);

  const handleLogout = async () => {
    try {
      const response = await fetch(
        `${import.meta.env.VITE_API_URL}/api/auth/logout`,
        {
          method: "POST",
          credentials: "include",
        }
      );
      if (response.ok) {
        toast({
          title: "Logged Out",
          description: "You have been logged out successfully.",
          variant: "default",
        });
        manualLogoutRef.current = true;
        logout();
      } else {
        const data = await response.json().catch(() => ({}));
        toast({
          title: "Logout Failed",
          description: data?.error || "Could not log out. Please try again.",
          variant: "destructive",
        });
      }
    } catch (err) {
      toast({
        title: "Logout Error",
        description: "Network error. Please try again.",
        variant: "destructive",
      });
    }
  };

  // const navItems = [
  //   {
  //     path: "/registration",
  //     label: "Vehicle Registration",
  //     icon: Car,
  //     roles: ["staff", "admin"],
  //   },
  //   {
  //     path: "/dashboard",
  //     label: "Admin Dashboard",
  //     icon: BarChart3,
  //     roles: ["admin"],
  //   },
  // ];

  // const filteredNavItems = navItems.filter((item) =>
  //   item.roles.includes(userRole)
  // );

  return (
    <nav className="bg-card border-b shadow-sm sticky top-0 z-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="flex items-center justify-between h-16">
          {/* Logo and Brand */}
          <div className="flex items-center gap-3">
            <div className="w-8 h-8 bg-primary rounded-lg flex items-center justify-center">
              <Shield className="w-5 h-5 text-primary-foreground" />
            </div>
            <div>
              <h1 className="text-lg font-bold text-foreground">
                Vehicle Registration
              </h1>
            </div>
          </div>

          {/* Navigation Links */}
          {/* <div className="flex items-center gap-4">
            {filteredNavItems.map((item) => {
              // Special handling for Vehicle Registration nav item
              if (item.label === "Vehicle Registration") {
                return (
                  <Button
                    key={item.path}
                    variant={
                      location.pathname === item.path ? "default" : "ghost"
                    }
                    onClick={() => {
                      if (userRole === "admin") {
                        navigate("/registration-form"); // Route for RegistrationForm.tsx
                      } else {
                        navigate("/registration"); // Route for VehicleRegistration.tsx
                      }
                    }}
                    className="flex items-center gap-2"
                  >
                    <item.icon className="w-4 h-4" />
                    {item.label}
                  </Button>
                );
              }
              // Default navigation for other items
              return (
                <Button
                  key={item.path}
                  variant={
                    location.pathname === item.path ? "default" : "ghost"
                  }
                  onClick={() => navigate(item.path)}
                  className="flex items-center gap-2"
                >
                  <item.icon className="w-4 h-4" />
                  {item.label}
                </Button>
              );
            })}
          </div> */}

          {/* User Info and Logout */}
          <div className="flex items-center gap-4">
            <div className="flex items-center gap-2">
              <User className="w-4 h-4 text-muted-foreground" />
              <span className="text-sm font-medium">{userName}</span>
              <Badge variant={userRole === "admin" ? "default" : "secondary"}>
                {userRole === "admin" ? "Administrator" : "Staff"}
              </Badge>
            </div>
            <Button variant="outline" size="sm" onClick={handleLogout}>
              <LogOut className="w-4 h-4 mr-2" />
              Logout
            </Button>
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navigation;
